import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ObjectType } from '@galaxy/crm/static';
import { FilterOperator } from '@vendasta/crm';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SupportedOperatorsPipe } from '../pipes/supported-operators.pipe';
import { OperatorNamePipe } from '../pipes/operator-name.pipe';

@Component({
  selector: 'crm-scoring-definition-field-operator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <glxy-form-field [showLabel]="false" bottomSpacing="none" [disabled]="!fieldId">
      <mat-select placeholder="Relation" [formControl]="formControl">
        @for (operator of fieldId | supportedOperators: objectType | async; track $index) {
          <mat-option [value]="operator">{{ operator | operatorName | translate }}</mat-option>
        }
      </mat-select>
    </glxy-form-field>
  `,
  imports: [
    GalaxyFormFieldModule,
    MatSelect,
    FormsModule,
    ReactiveFormsModule,
    MatOption,
    AsyncPipe,
    TranslateModule,
    SupportedOperatorsPipe,
    OperatorNamePipe,
  ],
})
export class ScoringDefinitionFieldOperatorComponent {
  @Input({ required: true }) fieldId?: string;
  @Input({ required: true }) objectType?: ObjectType;
  @Input()
  set value(value: FilterOperator | undefined) {
    this.formControl.setValue(value ?? FilterOperator.FILTER_OPERATOR_INVALID);
  }
  @Output() valueChange = new EventEmitter<FilterOperator>();

  protected readonly formControl = new FormControl<FilterOperator>(FilterOperator.FILTER_OPERATOR_INVALID, {
    nonNullable: true,
  });

  constructor() {
    this.formControl.valueChanges.subscribe((value) => this.valueChange.emit(value));
  }
}
